<template>
    <h3 class="text-foreground scroll-m-20 text-2xl font-semibold tracking-tight leading-8 ">
        <slot/>
    </h3>
</template>